import { compose, withProps, mapProps, withHandlers, withStateHandlers, lifecycle } from 'recompose'
import { handleAddNewVehicle } from 'actions/addVehicle'
import { showStoreLocatorModal } from 'actions/storeLocator'
import { COMPATIBILITY_STATUS_COMPATIBLE } from 'constant'
import { processProductsData, getSearchUrl } from 'helpers/global-search'
import { getCurrentStore, getActiveVehicle, getHasActiveVehicleStatus } from 'selectors'
import { getGlobalSearchDisplay } from '../../selectors'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import { formatPhoneNumber } from 'helpers/phone-number'
import withSetBazaarVoiceInlineRatings from 'components/common/hoc/withBazaarVoiceInlineRatings/withSetBazaarVoiceInlineRatings'
import resultBlockHoc from '../resultBlockHoc'
import Product from '../Product'
import SortableResultList from '../SortableResultList'
import { preLoadItems } from './actions'
import withType from 'components/common/hoc/withType'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'
import { getSearchUrlValue } from './helpers'
import { push } from 'connected-react-router'

const withViewAllRecords = withStateHandlers(({ lastRecNum, sortOptions, records = []}) => ({
  allRecords: [...records],
  isViewAll: true,
  recordIndex: lastRecNum,
  allSortOptions: sortOptions,
  preLoadedRecords: [],
  preLoadedSortOptions: [],
  noNewRecords: false
}), {
  setPreLoaderOptions: () => ({
    isViewAll,
    preLoadedSortOptions,
    preLoadedRecords,
    recordIndex,
    noNewRecords
  }) => ({
    isViewAll,
    preLoadedSortOptions,
    preLoadedRecords,
    recordIndex,
    noNewRecords
  }),
  setRecordOptions: ({ preLoadedRecords, preLoadedSortOptions, allRecords }) => ({ isViewAll }) =>
    ({
      allRecords: [...allRecords, ...preLoadedRecords],
      allSortOptions: preLoadedSortOptions,
      isViewAll
    }),
  resetRecords: () => ({
    records,
    recordIndex,
    sortOptions
  }) => ({
    allRecords: records,
    isViewAll: false,
    recordIndex,
    allSortOptions: sortOptions,
    preLoadedRecords: [],
    preLoadedSortOptions: [],
    noNewRecords: false
  }),
  setNoNewRecords: () => noNewRecords => ({ noNewRecords })
})

const withInitialization = lifecycle({
  componentDidMount() {
    const { onGlobalSearchPage, setPreLoaderOptions, recordIndex, preLoadItems, setNoNewRecords } = this.props
    if (!onGlobalSearchPage) {
      preLoadItems({
        setNoNewRecords,
        setPreLoaderOptions,
        index: recordIndex
      })
    }
  },
  componentDidUpdate({ vehicleName: prevVehicleName, initialRecords: prevInitialRecords }) {
    const {
      onGlobalSearchPage,
      setPreLoaderOptions,
      preLoadItems,
      resetRecords,
      initialRecords,
      initialSortOptions,
      setNoNewRecords,
      lastRecNum,
      vehicleName,
      push
    } = this.props

    if (!onGlobalSearchPage && !isEqual(initialRecords, prevInitialRecords)) {
      resetRecords({
        records: initialRecords,
        recordIndex: lastRecNum,
        sortOptions: initialSortOptions
      })
      preLoadItems({
        setNoNewRecords,
        setPreLoaderOptions,
        index: lastRecNum
      })
    }

    if (!isEqual(vehicleName, prevVehicleName)) {
      const searchValue = getSearchUrlValue(initialSortOptions[0].navigationState)

      push(getSearchUrl(searchValue))
    }
  }
})

const withScrollHandlers = withHandlers({
  infinityScrollHandler: ({
    isViewAll,
    recordIndex,
    setRecordOptions,
    setPreLoaderOptions,
    setNoNewRecords,
    preLoadItems
  }) => () => {
    if (isViewAll) {
      setRecordOptions({ isViewAll: false })
      preLoadItems({
        setNoNewRecords,
        setPreLoaderOptions,
        index: recordIndex
      })
    }
  }
})


const mapStateToProps = state => {
  const { vehicleName, hasStaggeredFitment } = getActiveVehicle(state)

  return {
    displayGlobalSearch: getGlobalSearchDisplay(state),
    hasStore: getCurrentStore(state),
    hasActiveVehicle: getHasActiveVehicleStatus(state),
    storePhoneNumber: getCurrentStorePhoneNumber(state),
    formattedStorePhoneNumber: formatPhoneNumber(getCurrentStorePhoneNumber(state)),
    vehicleName,
    hasStaggeredFitment
  }
}

const mapDispatchToProps = {
  showStoreLocatorModal,
  handleAddNewVehicle,
  preLoadItems,
  push
}

export default compose(
  withType({ type: 'BOTProductSearchResults' }),
  withViewAllRecords,
  mapProps(({
    records,
    onGlobalSearchPage,
    allRecords,
    allSortOptions,
    sortOptions,
    preLoadedRecords,
    noNewRecords,
    ...props
  }) => ({
    ...props,
    onGlobalSearchPage,
    allRecords,
    initialRecords: records,
    initialSortOptions: sortOptions,
    preLoadedRecords,
    noNewRecords,
    sortOptions: onGlobalSearchPage ? sortOptions : allSortOptions,
    records: onGlobalSearchPage ? records : allRecords,
    showSpinner: !isEmpty(preLoadedRecords) && !noNewRecords,
    BOTProductSearchResults: true
  })),
  resultBlockHoc({
    TileComponent: Product,
    blockName: 'Product',
    mapDispatchToProps,
    mapStateToProps,
    processData: processProductsData,
    type: 'BOTProductSearchResults'
  }),
  withProps(({ tiles, vehicleName }) => ({
    showCompatibility: vehicleName && !tiles.every(({ compatibilityStatus }) =>
      compatibilityStatus === COMPATIBILITY_STATUS_COMPATIBLE
    )
  })),
  withInitialization,
  withScrollHandlers,
  withSetBazaarVoiceInlineRatings
)(SortableResultList)
